"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var DirectDebitFunctions_1 = require("./DirectDebitFunctions");
var commonFunctions_1 = require("../../../../commonFunctions");
var DirectDebitPaymentSchedule = /** @class */ (function (_super) {
    __extends(DirectDebitPaymentSchedule, _super);
    function DirectDebitPaymentSchedule(props) {
        var _this = _super.call(this, props) || this;
        _this.progressContainerRef = React.createRef();
        _this.lastDoneInstalmentDotRef = React.createRef();
        _this.renderHorizontalDots = function () {
            return _this.props.instalments.map(function (instalment, index) {
                var isDone = index <= _this.state.lastDoneInstalmentIndex;
                return ((0, jsx_runtime_1.jsx)("div", { className: "progress-dot".concat(isDone ? " progress-dot--paid" : ""), ref: index === _this.state.lastDoneInstalmentIndex ? _this.lastDoneInstalmentDotRef : undefined }, index));
            });
        };
        _this.renderVerticalDotsWithSchedule = function () {
            var firstInstalmentDueDate = (0, DirectDebitFunctions_1.getFirstInstalmentDueDate)(_this.props.interaction);
            return _this.props.instalments.map(function (instalment, index, instalments) {
                var amount = instalment.principal + instalment.interest;
                return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__grid-item instalment-text-color", children: _this.props.interaction.status === 'MIGRATED_RENEWAL_TEMP'
                                ? (0, commonFunctions_1.formatDate)(instalment.dueDate, "DD MMM YYYY")
                                : (index === 0
                                    ? firstInstalmentDueDate.format("DD MMM YYYY")
                                    : firstInstalmentDueDate.add(1, 'months').format("DD MMM YYYY")) }), (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__grid-item", children: (0, jsx_runtime_1.jsx)("div", { className: "progress-dot", ref: index === _this.state.lastDoneInstalmentIndex ? _this.lastDoneInstalmentDotRef : undefined }) }), (0, jsx_runtime_1.jsxs)("div", { className: "payment-schedule__grid-item payment-plan-item instalment-text-color", children: ["\u00A3".concat(amount.toFixed(2)), " ", index === 0 ? "(1st pay)" : ""] })] }, index));
            });
        };
        _this.state = {
            lastDoneInstalmentIndex: -1
        };
        return _this;
    }
    DirectDebitPaymentSchedule.prototype.componentWillUnmount = function () {
        if (this.windowResizeEventSubscription) {
            this.windowResizeEventSubscription.unsubscribe();
        }
    };
    DirectDebitPaymentSchedule.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "payment-schedule ".concat(this.props.isOpen ? "payment-schedule--open" : ""), children: [(0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress-container", ref: this.progressContainerRef, children: (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress", children: (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress-bar" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__dot-container", children: this.props.isOpen ? this.renderVerticalDotsWithSchedule() : this.renderHorizontalDots() })] }));
    };
    return DirectDebitPaymentSchedule;
}(React.Component));
exports.default = DirectDebitPaymentSchedule;
//# sourceMappingURL=DirectDebitPaymentSchedule.js.map